import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { ERROR_MESSAGE } from './constants';

const previewReady = async ({ variationId, flowName }) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'previewReady' });

    try {
        const { data } = await axios.post(requestUrl, { variationId, flowName });
        return data.success;
    } catch (e) {
        logAPIError(e, { message: ERROR_MESSAGE, requestUrl, method: 'post', params: { variationId, flowName } });
        return false;
    }
};

export default previewReady;
